/** EST3 subcontract quote qualities — mirrors backend QUOTE_QUALITIES. */
export const EST3_QUOTE_QUALITIES = ['FIRM', 'BUDGETARY', 'HISTORICAL', 'MANUAL'] as const;

export type Est3QuoteQuality = (typeof EST3_QUOTE_QUALITIES)[number];

/** Package coverage statuses — mirrors backend SUBCONTRACT_COVERAGE_STATUSES. */
export const EST3_COVERAGE_STATUSES = [
  'UNQUOTED',
  'BUDGETARY',
  'FIRM',
  'HISTORICAL',
  'MANUAL',
] as const;

export type Est3CoverageStatus = (typeof EST3_COVERAGE_STATUSES)[number];

export function est3CoverageStatusColor(status: string): string {
  switch (status) {
    case 'FIRM':
      return 'green';
    case 'BUDGETARY':
      return 'blue';
    case 'HISTORICAL':
      return 'default';
    case 'MANUAL':
      return 'purple';
    case 'UNQUOTED':
      return 'orange';
    default:
      return 'default';
  }
}

export function summarizeCoverageByStatus(
  byStatus: Record<string, { amount?: number; count?: number; pct?: number }> | undefined
): Array<{ status: string; amount: number; count: number; pct: number }> {
  if (!byStatus) return [];
  return EST3_COVERAGE_STATUSES.map((status) => ({
    status,
    amount: Number(byStatus[status]?.amount) || 0,
    count: Number(byStatus[status]?.count) || 0,
    pct: Number(byStatus[status]?.pct) || 0,
  })).filter((x) => x.count > 0 || x.amount > 0);
}
